module.exports = __webpack_public_path__ + "img/header.62ef75ad.png";